var React = require('react');

function DownArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m482.140625 639 12.352941 13.031674-.000566.128326 12.366375-13.044615 5.140625 5.423077-17.5 18.461538-5.140625-5.423077.053625-.057923-12.413-13.095923z","fill":"#fff","fillRule":"evenodd","transform":"translate(-477 -639)"}));
}

DownArrow.defaultProps = {"height":"24","viewBox":"0 0 35 24","width":"35"};

module.exports = DownArrow;

DownArrow.default = DownArrow;
